import { getRoundedNumber } from '../../../../../shared/utils/mathUtils';
import { FoodDetails } from '../../../../interfaces/FoodDetails';
import {
  FOOD_FORM_NUTRIENTS,
  FoodFormNutrient,
  NUTRIENT_ROUNDING_PRECISION,
} from '../../constants/foodFormNutrients';
import { FoodFormValues } from '../../interfaces/FoodFormValues';

/**
 * Amounts arrive per unit and become totals for `recommendedServingSize`. A Nutritionix search row
 * has serving size 1, so the same rule covers every source.
 */
export const foodToFormValues = (food: FoodDetails): FoodFormValues => {
  const amount = food.recommendedServingSize;
  const toTotal = (value: number) =>
    getRoundedNumber(value * amount, NUTRIENT_ROUNDING_PRECISION);

  const scaledNutrients = Object.fromEntries(
    FOOD_FORM_NUTRIENTS.map((key) => [key, toTotal(food[key])]),
  ) as Record<FoodFormNutrient, number>;

  const scaledMicroNutrients = food.microNutrients.map((micro) => ({
    ...micro,
    amount: toTotal(micro.amount),
  }));

  return {
    nutrients: scaledNutrients,
    id: food.id,
    activeCalendar: food.activeCalendar,
    name: food.name_only ?? '',
    brand: food.brand ? { value: food.brand, label: food.brand } : null,
    amountUnit: food.amountUnit ?? '',
    recommendedServingSize: amount,
    barcode: food.barcode ?? '',
    servingSize: food.servingSize || '',
    servingPerContainer: food.servingPerContainer || '',
    totalPerContainer: food.totalPerContainer || null,
    tags: food.tags || [],
    recommended: food.recommended,
    microNutrients: scaledMicroNutrients,
    my_net_diary_bean_id: food.my_net_diary_bean_id,
  };
};
